import { RootState } from 'app/store/types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useUIEffect = () => {
  const [isModalShown, setIsModalShown] = useState<boolean>(false);
  const uiState = useSelector((state: RootState) => state.UI);

  useEffect(() => {
    const modalsState = uiState.modals;
    // 當頁面上的小日曆或側邊選單被開啟
    if (uiState.isCalendarOpen ||
      uiState.isMobileNavOpen) {
      setIsModalShown(true);
      return;
    }
    // 當有視窗被開啟
    if (modalsState.idleModalVisible ||
      modalsState.memberLoginModalVisible ||
      modalsState.memberProfileLoginRecordModalVisible ||
      modalsState.memberRegisterNSModalVisible ||
      modalsState.homeMainNewsContentModalVisible ||
      modalsState.homeTravelInsClaimDocumentsModalVisible
    ) {
      setIsModalShown(true);
      return;
    }
    setIsModalShown(false);
  }, [uiState]);

  return isModalShown;
};

export default useUIEffect;
